import * as yup from 'yup';
import { DateTime } from 'luxon';
import { ADULT_MIN_AGE, DEFAULT_MAX_STRING_MSG, NativeLangEnum, STRING_DEFAULT_MAX_LENGTH, VALIDATORS } from 'core';
import { CHILD_PROTECTION_VALIDATION_SCHEMA } from 'components/ChildProtection/validationSchema';
import { ForWhom } from 'store/candidate/types';
import { MalaysianCitizenStatus } from 'core/const/MalaysianCitizenStatus';

const isMyself = (forWhom: ForWhom) => forWhom === ForWhom.Myself;
const isNotMyself = (forWhom: ForWhom) => forWhom !== ForWhom.Myself;

export const VALIDATION_SCHEMA = yup.object().shape({
  ...VALIDATORS.address.fields,
  telephone: yup.string().when('forWhom', {
    is: isMyself,
    then: VALIDATORS.telephone,
  }),
  mobile: yup.string().when('forWhom', {
    is: isMyself,
    then: VALIDATORS.telephone.required('Mobile number is required.'),
  }),
  taxNumber: yup.string().max(STRING_DEFAULT_MAX_LENGTH, DEFAULT_MAX_STRING_MSG),
  panNumber: yup.string().max(9, DEFAULT_MAX_STRING_MSG),
  firstName: VALIDATORS.firstName,
  lastName: VALIDATORS.lastName,
  dateOfBirth: VALIDATORS.dateOfBirth.when('forWhom', {
    is: (fromWho: ForWhom) => fromWho === ForWhom.NewChild,
    then: yup
      .date()
      .min(DateTime.local().minus({ years: ADULT_MIN_AGE }).toJSDate(), 'Child should be under 18 years of age'),
  }),
  gender: yup.string().required('Gender is required.'),
  nativeLanguage: yup
    .number()
    .required('English native language is required.')
    .oneOf(
      [Number(NativeLangEnum.Unknown), Number(NativeLangEnum.Yes), Number(NativeLangEnum.No)],
      'English native language is required.'
    ),
  email: yup.string().when('forWhom', {
    is: isMyself,
    then: VALIDATORS.email,
  }),
  confirmationSelected: yup.boolean().isTrue('Please confirm the details.'),
  guardianContactDetails: yup.object().when('forWhom', {
    is: isNotMyself,
    then: yup.object().shape({
      familyRelationshipId: yup.number().required('Relationship to the child is required.'),
      telephone: VALIDATORS.telephone,
      mobile: VALIDATORS.telephone.required('Mobile number is required.'),
    }),
  }),

  childDetails: yup.object().when('forWhom', {
    is: isNotMyself,
    then: CHILD_PROTECTION_VALIDATION_SCHEMA,
  }),

  isMalaysianCitizen: yup.object().nullable(),
});

export const REQUIRED_NATIVE_LANGUAGE_RULE = yup.object().shape({
  nativeLanguage: yup
    .number()
    .oneOf(
      [Number(NativeLangEnum.Yes), Number(NativeLangEnum.No)],
      'Native language must be defined for the checkpoint session registration.'
    ),
});

export const MALAYSIA_CITIZEN_VALIDATION_RULE = yup.object().shape({
  isMalaysianCitizen: yup.string().required('Please specify if you are Malaysian citizen.')
  .oneOf(
      [String(MalaysianCitizenStatus.Yes), String(MalaysianCitizenStatus.No)],
      'Please specify if you are Malaysian citizen.'
    ),
});
